import { Common, Documents, Pagination } from '@factorin/domain';

import { get, post, withUrl, list, Request } from '../rest';


type Download =
    Request.DownloadProgress &
    Request.Cancel & {
        id: string;
    };

type Upload =
    Request.Query &
    Request.UploadProgress &
    Request.Cancel & {
        data: any;
    };

type UploadWarrant = Upload & {
    registerUid: string;
}

type RegistersHashRequest = {
    registerUids: string[];
    hashAlgorithm: string;
    base64?: boolean;
};

type RegisterForSignResponse = {
    RegisterUid: string;
    DocumentForSignUid: string;
    Hash: string;
};

type RegistersHashResponse = RegisterForSignResponse[];

type DocumentHashRequest = {
    documentId: string;
    hashAlgorithm: string;
    base64?: boolean;
};

type DocumentForSignResponse = {
    DocumentId: number;
    Hash: string;
};

interface DocumentListRequest extends Pagination.Request {
    id?: number;
    number?: string;
    dateRange?: Common.DateRange;
    documentTypeCode?: string;
}

type ProtocolRequest =
    Request.DownloadProgress &
    Request.Cancel & {
        id: string;
    };

const documentsPart = withUrl('documents');

export const documents = {
    ...list<Documents.Document, DocumentListRequest>(documentsPart()),

    download: get<Download>(
        ({ id, ...request }) => documentsPart({
            path: `${id}/download`,
            responseType: 'blob',
            ...request,
        }),
    ),

    upload: post<Upload, void>(
        ({ data, ...request }) => documentsPart({
            path: 'upload',
            contentType: 'multipart/form-data',
            body: data,
            ...request,
        }),
    ),

    uploadWarrant: post<UploadWarrant, void>(
        ({ data, registerUid, ...request }) => documentsPart({
            path: 'uploadwarrant',
            query: {
                registerUid,
            },
            contentType: 'multipart/form-data',
            body: data,
            ...request,
        }),
    ),

    registerHashes: get<RegistersHashRequest, RegistersHashResponse>(
        ({ registerUids, hashAlgorithm, base64 = false }) => documentsPart({
            path: 'hashes',
            query: {
                hashAlgorithm,
                registerUids,
                base64,
            },
        }),
    ),

    documentHash: get<DocumentHashRequest, DocumentForSignResponse>(
        ({ documentId, hashAlgorithm, base64 = false }) => documentsPart({
            path: 'hashes',
            query: {
                hashAlgorithm,
                documentId,
                base64,
            },
        }),
    ),

    downloadProtocol: get<ProtocolRequest>(
        ({ id, ...request }) => documentsPart({
            path: `${id}/protocol/download`,
            responseType: 'blob',
            ...request,
        }),
    ),
};
